<div class="sidebar">
	<app-sidebar-header></app-sidebar-header>
	<app-sidebar-nav></app-sidebar-nav>
	<app-sidebar-minimizer></app-sidebar-minimizer>
	<app-sidebar-footer></app-sidebar-footer>
</div>
